import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';
import {useHistory} from 'react-router-dom';
import Subtotal from '../Subtotal';
import { useIsStepAllowed, useSteps } from '../stepper';
import { useShouldShowSubtotal } from '../Subtotal/hooks';
import IconArrowRight from '../icons/IconArrowRight';

import NavButton from './NavButton';
import styles from './NextStepButton.module.css';

const NextStepButton = ({ intl, onClick, step, type = 'submit' }) => {
  const isNextStepAllowed = useIsStepAllowed(step + 1);
  const steps = useSteps(intl);
  const nextStep = steps[step + 1];
  const history = useHistory();
  const clickHandler = useCallback(() => (
    history.push(nextStep.url),
    onClick && onClick()
  ), [history, nextStep.url, onClick]);
  const shouldShowSubtotal = useShouldShowSubtotal();
  return (
    <div className={styles.wrapper}>
      {shouldShowSubtotal && <Subtotal />}
      {isNextStepAllowed &&
        <NavButton
          cssmodule={styles}
          iconAfter={<IconArrowRight />}
          onClick={clickHandler}
          text={nextStep.title}
          type={type}
        />}
    </div>
  );
};

NextStepButton.propTypes = {
  step: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['submit', 'button'])
};

export default injectIntl(NextStepButton);
